import React, { useRef, useLayoutEffect } from 'react';
import { map } from 'lodash';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { pieChartWidget as PieChartWidget } from 'ui/views/widgets/pieChartWidget';
 *
 * // render
 * <PieChartWidget propName='propValue'/>
 */

export const pieChartWidgetSuccess = ( props ) => {
	const chart = useRef( null );

	let legend2;
	let visible = false;

	useLayoutEffect( () => {
		const x = am4core.create( 'chart-div', am4charts.PieChart );

		x.paddingRight = 20;

		x.data = props.data;

		// Add and configure Series
		const pieSeries = x.series.push( new am4charts.PieSeries() );
		pieSeries.dataFields.value = 'value';
		pieSeries.dataFields.category = 'name';
		pieSeries.labels.template.text = '{value}';
		pieSeries.slices.template.stroke = am4core.color( '#ffffff' );
		pieSeries.slices.template.tooltipText =
			'{name}: {value}({percentageValue})';

		x.radius = am4core.percent( 95 );
		x.logo.disabled = true;

		/* Create legend */
		x.legend = new am4charts.Legend();

		// creating another div for extra legends
		legend2 = x.chartAndLegendContainer.createChild( am4core.Container );

		// legend2.layout = 'fixed';
		// legend2.isMeasured = false;
		legend2.margin( 10, 5, 0, 10 );
		legend2.valign = 'bottom';
		legend2.layout = 'vertical';

		// legend2.rangeChangeDuration = true;

		legend2.background.fill = am4core.color( '#ccc' );

		legend2.zIndex = 9999;

		// x.hideOverflow = false;

		// legend2.x = 550;
		// legend2.y = 50;
		legend2.hide();

		// adding extra legends to the second div
		x.legend.events.on( 'datavalidated', function () {
			for ( let i = 8; i < props.data.length; i = i + 1 ) {
				x.legend.itemContainers.getIndex( i ).parent = legend2;
			}
		} );

		// remove toggle and making slice active on the onclick
		x.legend.itemContainers.template.togglable = false;
		x.legend.itemContainers.template.events.on( 'hit', function ( ev ) {
			const slice = ev.target.dataItem.dataContext.slice;
			pieSeries.slices.each( function ( item ) {
				if ( item !== slice ) {
					item.isActive = false;
				} else {
					slice.isActive = !slice.isActive;
				}
			} );
		} );

		// markers shape to square
		x.legend.useDefaultMarker = true;
		const markerTemplate = x.legend.markers.template;
		markerTemplate.width = 10;
		markerTemplate.height = 10;

		// making marker square
		const marker = x.legend.markers.template.children.getIndex( 0 );
		marker.cornerRadius( 0, 0, 0, 0 );

		// position and scroll of legends
		x.legend.position = 'right';
		x.legend.maxWidth = 120;

		// x.legend.scrollable = true;

		// labels of legends
		x.legend.valueLabels.template.disabled = true;
		pieSeries.legendSettings.labelText = '{name}';

		chart.current = x;

		return () => {
			x.dispose();
		};
	}, [] );

	const abc = () => {
		visible ? legend2.hide() : legend2.show();
		visible = ! visible;
	};

	return (
		<div className="ui-pie-chart-widget">
			<div id="chart-div" style={{ width: '700px', height: '277px', overflow: 'visible' }}></div>
			<div className="ui-pie-chart-widget__legend-div" onClick={abc} >
				<div className="ui-pie-chart-widget__legend-div__marker"></div>
				<div className="ui-pie-chart-widget__legend-div__text">Others</div>
			</div>
		</div>
	);
};

// set display name
pieChartWidgetSuccess.displayName = 'pieChartWidget';

// set default props
pieChartWidgetSuccess.defaultProps = {};

// prop types
pieChartWidgetSuccess.propTypes = {};

/* ******************************************************** */

export const pieChartPreloader = () => {
	return (
		<div className="ui-pie-chart-preloader">
			<div className="ui-pie-chart-preloader__chart">
				<div className="ui-pie-chart-preloader__chart__legend"></div>
			</div>
			<div className="ui-pie-chart-preloader__details">
				{map( [ 1, 2, 3, 4 ], ( item ) => {
					return (
						<div key={'bar-loader' + item}>
							<div className="ui-pie-chart-preloader__details__section">
								<div className="ui-pie-chart-preloader__details__section__label" />
								<div className="ui-pie-chart-preloader__details__section__value" />
							</div>
							<div className="ui-pie-chart-preloader__details__section">
								<div className="ui-pie-chart-preloader__details__section__label" />
								<div className="ui-pie-chart-preloader__details__section__value" />
							</div>
						</div>
					);
				} )}
			</div>
		</div>
	);
};

// set display name
pieChartPreloader.displayName = 'pieChartPreloader';

// set default props
pieChartPreloader.defaultProps = {};

// prop types
pieChartPreloader.propTypes = {};

/* ******************************************************** */

export const pieChartWidget = withNetworkState(
	pieChartPreloader,
	pieChartWidgetSuccess
);
